import React, { useState, useEffect } from 'react';
import { StyleSheet } from 'react-native';
import { Table } from '../../interfaces';
import Select from 'react-select'; 

interface ChangeTablePopupProps {
    onClose: () => void;
    onChangeTable: (tableId: string, tableName: string) => void;
    tables: Table[] | null;
    currentTable: string;
}


const ChangeTablePopup: React.FC<ChangeTablePopupProps> = ({ onClose, onChangeTable, tables, currentTable }) => {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    const [selectedTable, setSelectedTable] = useState<{ value: string; label: string } | null>(null);
    const tableOptions = tables?.map((table) => ({
        value: table.id,
        label: table.tableNo,
    }));

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);


    useEffect(() => {
        const handleResize = () => {
            console.log("onresize: innerWidth: " + window.innerWidth + "innerHeight: " + innerHeight)
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.onresize = handleResize;

        return () => {
            window.onresize = null;
        };
    }, []);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        const updateSize = () => {
            console.log("update size")
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", updateSize);
        window.addEventListener("focus", updateSize);
        document.addEventListener("visibilitychange", updateSize);

        return () => {
            window.removeEventListener("resize", updateSize);
            window.removeEventListener("focus", updateSize);
            document.removeEventListener("visibilitychange", updateSize);
        };
    }, []);

    const onSave = () => {
        if (selectedTable) {
            onChangeTable(selectedTable.value, selectedTable.label);
        }
        else{
            onClose();
        }
    }

    const styles = StyleSheet.create({
        popup: {
            width: windowSize.width > 900 ? windowSize.width * 0.40 : windowSize.width * 0.9,
            backgroundColor: '#fff',
            position: 'absolute',
            zIndex: 1000,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },
    });

    return (
        <div style={styles.popup} className='ds-pop ds-pop--center'>
            <div className='d-flex px-3 pt-3 justify-content-end'>
                <button className='text-btn p-0 m-0 d-flex justify-content-center' onClick={onClose}>
                    <svg width="10" height="10" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 1L1 13M1 1L13 13" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>

            <div className='px-4 pb-3 d-flex flex-column'>
                <h5>Change Table</h5>
                <p>Select a new table number to apply for this specific order.</p>
                <label className='mt-2'>Current table: {currentTable}</label>
                <label className='mt-3'>Select from available tables</label>
                <Select
                    options={tableOptions}
                    value={selectedTable}
                    onChange={(selected) => setSelectedTable(selected)}
                    placeholder="Select a table"
                    className='mt-1'
                    menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
                    menuPosition="fixed"
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 2000 }) }}
                />
            </div>
            <div className='p-2 d-flex mt-3 gap-2 justify-content-end align-items-center' style={{ backgroundColor: '#F3F4F6' }}>
                <button className='white-filled-btn' onClick={onClose}>Cancel</button>
                <button className='blue-filled-btn' onClick={onSave} style={{border: 'none', height: 34.5}}>Change Table</button>
            </div>
        </div>
    );
};

export default ChangeTablePopup;

